import React, { useEffect } from 'react';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  UtilityText,
  HeadingText,
  Button,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { DOCUMENT_CENTER_ASSET_KEYS } from '../types/document-center.types';
import * as CONSTANTS from '../utils/constant';

export const ErrorModal = (props: any) => {
  const { onClose }: { onClose: () => void } = props;
  const attentionIcon = useStaticAsset(
    DOCUMENT_CENTER_ASSET_KEYS.ATTENTION_ICON,
  );

  useEffect(() => {
    document.getElementById('errorBtn')?.click();
  }, []);

  return (
    <Modal.Root>
      <Modal.Trigger>
        <Button
          id="errorBtn"
          css={
            {
              visibility: 'hidden',
            } as GDSStyleObject
          }
        >
          {CONSTANTS.OPEN_ERROR_MODAL}
        </Button>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 650, '@mobile': '100%' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            <img
              src={attentionIcon as string}
              alt="right arrow icon"
              width="40px"
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              data-testid="oops"
              size="sm"
              css={{ padding: '24px $none' } as GDSStyleObject}
            >
              {CONSTANTS.WENT_WRONG}
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            {CONSTANTS.ERROR_MESSAGE}
          </ParagraphText>
          <ParagraphText emphasis="subtle">
            {CONSTANTS.PLEASE_TRY_AGAIN}
          </ParagraphText>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$two $four 16px $four',
                justifyContent: 'space-around',
              } as GDSStyleObject
            }
          >
            <UtilityText
              css={{
                color: '#0074C9',
                cursor: 'pointer',
              }}
              onClick={onClose}
              data-testid="closeBtn"
            >
              {CONSTANTS.OK}
            </UtilityText>
          </Box>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
};
